import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useAppEvenListSelector, useAppGameDetailsSelector } from "src/_common/hooks/selectors/eventSelector";
import { CRYPTO_SECRET_KEY } from "src/_config";

// interface SponsorProps {
//     details?: any
// }

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function Sponsor() {
  const [details, setDetails] = useState<any>();
  const { eventId } = useParams<any>();

  const gameDetails = useAppGameDetailsSelector();
  const eventList = useAppEvenListSelector();

  useEffect(() => {
    // console.log({details})
  }, [details]);

  useEffect(() => {
    if (eventId) {
      let e_id = parseInt(cryptr.decrypt(eventId));
      let r_event = eventList?.list?.find((x: any) => x.id == e_id);
      if (r_event?.rodeo_event_game_info?.sponsor) {
        setDetails(r_event?.rodeo_event_game_info?.sponsor);
      }
    } else {
      if (gameDetails?.sponsor_image) {
        setDetails(gameDetails?.sponsor_image);
      }
    }
  }, [eventId, gameDetails, eventList]);

  return (
    <>
      {/* {details?.id!=0 && details?.original ? <div className="sponsor-com-img-wrap">
                <span>Sponsored by:</span>
                <a>
                    <img src={details?.original} alt="Sponsor Image" />
                </a>
            </div> : null} */}
      <div className="app-footer d-flex justify-content-between align-items-center">
        <p>Powered by</p>
        <img src="/images/teton-ridge.svg" />
      </div>
    </>
  );
}
